import * as React from 'react'
import { PaymentsContextType } from './types'

export const PaymentsContext = React.createContext<PaymentsContextType>(
  {} as PaymentsContextType
)
